import React from 'react';
import { motion } from 'framer-motion';
import { MathScene } from './scenes/MathScene';
import { Analytics } from "@vercel/analytics/react"
import './styles/App.css';
// This tracks the current page view and all future ones as well

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <motion.h1 
          initial={{ y: -100 }}
          animate={{ y: 0 }}
          transition={{ type: "spring", stiffness: 260, damping: 20 }}
        >
          Math Adventure for Kids!
        </motion.h1>
      </header>
      <main>
        <MathScene />
        <Analytics />
      </main>
    </div>
  );
}


export default App;